import { alias, notEmpty } from '@ember/object/computed';
import Controller from '@ember/controller';
import { computed, get } from '@ember/object';

export default Controller.extend({
  goal: alias('model.dashboard.goal'),
  fund: alias('model.fund'),

  supportTarget: alias('goal.goalData.support_target'),
  supportTargetPresent: notEmpty('supportTarget'),
  supportLevel: alias('goal.goalData.support_level'),
  supportLevelRounded: computed('supportLevel', function () {
    return Math.round(this.supportLevel);
  }),
  supportDate: alias('goal.goalData.support_level_date'),
});
